const BASE_BACKEND_URL = process.env.BACKEND_URL;

export const sendReportEmail = async ({
  email,
  file,
  reportFormat,
  stationName,
}) => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("file", file);
  formData.append("format", reportFormat);
  formData.append("stationName", stationName);

  const response = await fetch(`${BASE_BACKEND_URL}/reports/send`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Failed to send email");
  }
};
